export default __webpack_public_path__ + "static/media/planet-5.1a933634.svg";